import { Button } from '../../components';
import React from 'react';
import { RewardPointDetailsService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import  '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchCreditList: any;
  creditValue: any;
  setShowOverlay: any;
}
const RewardPointSave: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchCreditList,
    creditValue,
    setShowOverlay,
  } = props;

  const [save, setSave] = React.useState(false);
  const blockService = () => {
    setShowOverlay(true);
    RewardPointDetailsService.updatePoints({
      rewardPointId: id,
      points: creditValue,
    }).then(() => {
      setShowOverlay(false);
      setSave(true);
    });
  };

  return (
    <>
      {!save ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Save
          </h2>
          <p>
            Are you sure you want to save the entered value?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button onClick={blockService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Saved successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchCreditList();
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default RewardPointSave;
